import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';


import { useTranslation } from 'react-i18next';

// subtitle es true en las pantallas de registro
export function AppLogo({subtitle}) {

    const {t, i18n} = useTranslation()
    const {logo, accentFontColor, customStyle, logoSignup, showLabel} = useSelector(state => state.customizables);

    const containerStyle = subtitle ? {
        margin: 'auto',
        marginBottom: '20px'
        } : {};

    let label = null;
    if(showLabel) {
        const lang = i18n.language.split('-')[0];
        const parsedLabel = JSON.parse(showLabel);
        label = parsedLabel[lang] ?? parsedLabel['es'];
    }


    return customStyle !== undefined ?
        <React.Fragment>
            <div style={{
                    display: 'flex',
                flexDirection: 'column',
                justifyContent: 'right',
                alignItems: 'start',
                width: '300px',
                ...containerStyle
                }}>
                <img
                    src={subtitle ? logoSignup : logo}
                    alt="logo"
                    style={{
                        position: 'inherit',
                        maxWidth: '300px',
                        maxHeight:  '60px',
                    }}/>
                {
                    label ?
                        <div style={{
                            width: '100%',
                            fontSize: '11px',
                            marginLeft: '50px',
                            marginTop: '5px'
                        }}>{label}</div> : null
                }
            </div>
            {
                subtitle ?
                <p style={{fontSize:'10px', fontWeight:'bold', color:accentFontColor}}>
                    {t('signQuickly1')} <br/>
                    {t('signQuickly2')}
                </p> : null
            }
        </React.Fragment> : <div></div>
}

export function ImgSuccess() {
    const {imgSuccess } = useSelector(state => state.customizables)

    return imgSuccess ?
        <img src={imgSuccess} alt="exito"
            style={{
                maxHeight: '200px'
            }}></img> : <div></div>
}

export function ImgLoading() {
    const { loading } = useSelector(state => state.customizables)

    return loading ?
        <img src={loading} alt="loading"
            style={{
                maxHeight: '200px'
            }}></img> : <div></div>
}

export function ImgFirmando() {
    const { signing } = useSelector(state => state.customizables)

    return signing ?
        <img src={signing} alt="signing"
            style={{
                maxHeight: '200px'
            }}></img> : <div></div>
}

export function ImgLogo() {
    const { logo } = useSelector(state => state.customizables)

    return logo ?
        <img src={logo} alt="logo"
            style={{
                maxHeight: '100px'
            }}></img> : <div></div>
}

export function ImgSticker({activeSigner, data}) {
    const {imgSticker, customStyle} = useSelector(state => state.customizables)
    const {t} = useTranslation()

    return customStyle !== undefined && imgSticker ?
        <img src={imgSticker} alt={t("firme aqui")}
            style={{
                opacity: activeSigner ? activeSigner === data ? 1 : 0.05 : 1,
                height: '90%'
            }}></img> : <div></div>
}

export function usePalette() {
    const {customStyle, palette} = useSelector(state => state.customizables);
    return customStyle !== undefined ? palette : { waiting: true, styles: {}};
}

export function useAutoSignAll() {
    const {autoSignAll} = useSelector(state => state.customizables);
    return autoSignAll;
}
